import { PropsWithChildren } from 'react';
import { Typography } from '../Atoms';

type IProps = PropsWithChildren<{
  active?: boolean;
  onClick?: () => void;
}>;

const CommandCenterTabItem = (props: IProps) => (
  <Typography
    className={`lg:text-[11px]  cursor-pointer transition-all ${props.active ? 'text-[#00d0ab] border-b-[1px] border-b-[#00D0AB]' : 'text-[#979797]'}`}
    size='s16ToS12'
    onClick={props.onClick}
  >
    {props.children}
  </Typography>
);

export default CommandCenterTabItem;
